import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { Age } from "Globals/Models/Age";

export class AgeStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private age: Age[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.age = initialState.ages;
    }

    @MobX.action
    public getAgeName(ageId: string | null): string {
        if (ageId == "0" || ageId == null || ageId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => ageId === value.id);
        return value ? value.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): Age[] {
        return this.age.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getAgeOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "placeholder",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
